var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": false,
          "show-delete": false,
          "show-save": false,
          "show-print": false,
          "show-new": false,
          "show-cancel": false,
        },
      }),
      _c("div", { staticClass: "m-3" }, [
        _c(
          "article",
          { staticClass: "box" },
          [
            _c("label", { staticClass: "label" }, [_vm._v("Quote No.")]),
            _c("div", { staticClass: "field has-addons" }, [
              _c("div", { staticClass: "control is-expanded" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.quoteNo,
                      expression: "quoteNo",
                    },
                    { name: "focus-inserted", rawName: "v-focus-inserted" },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: {
                    placeholder: "Start typing to search...",
                    disabled: _vm.isUploading,
                  },
                  domProps: { value: _vm.quoteNo },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.quoteNo = $event.target.value
                      },
                      _vm.searchQuote,
                    ],
                  },
                }),
                _vm.validQuote
                  ? _c("span", { staticClass: "help is-success" }, [
                      _vm._v("Valid Quote No."),
                    ])
                  : _vm.quoteNo.length > 0
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Invalid Quote No."),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "control" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-primary",
                    attrs: { disabled: _vm.isUploading || !_vm.validQuote },
                    on: { click: _vm.dropzoneRemoveAllFiles },
                  },
                  [_vm._m(0), _c("span", [_vm._v("Clear")])]
                ),
              ]),
              _c("div", { staticClass: "control" }, [
                _c(
                  "a",
                  {
                    staticClass: "button is-success",
                    attrs: { disabled: _vm.isUploading || !_vm.validQuote },
                    on: { click: _vm.upload },
                  },
                  [_vm._m(1), _c("span", [_vm._v("Upload")])]
                ),
              ]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isDropzoneActive && _vm.isMobile.any(),
                    expression: "isDropzoneActive && isMobile.any()",
                  },
                ],
                staticClass: "field",
              },
              [
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "select" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.dropzoneOptions.capture,
                            expression: "dropzoneOptions.capture",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.dropzoneOptions,
                              "capture",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            domProps: {
                              value: _vm.mobileImageSourceType.Gallery,
                            },
                          },
                          [_vm._v("From Gallery")]
                        ),
                        _c(
                          "option",
                          {
                            domProps: {
                              value: _vm.mobileImageSourceType.Camera,
                            },
                          },
                          [_vm._v("From Camera")]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm.validQuote && _vm.isDropzoneActive
              ? _c("vue-dropzone", {
                  ref: "quoteImageDropzone",
                  attrs: { id: "dropzone", options: _vm.dropzoneOptions },
                  on: {
                    "vdropzone-mounted": _vm.dropzoneMounted,
                    "vdropzone-file-added": _vm.dropzoneFileAdded,
                    "vdropzone-success": _vm.dropzoneSuccess,
                    "vdropzone-error-multiple": _vm.dropzoneErrorMultiple,
                    "vdropzone-sending": _vm.dropzoneSending,
                    "vdropzone-total-upload-progress":
                      _vm.dropzoneTotalUploadProgress,
                    "vdropzone-complete-multiple": _vm.dropzoneCompleteMultiple,
                    "vdropzone-queue-complete": _vm.dropzoneQueueComplete,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-upload mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }